import React, { useEffect } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ShowWhen } from "../ShowWhen";
import Lottie from "react-lottie";
import LoaderData from "./loader.json";

export function FmPageLoader() {
  const { t } = useTranslation();

  useEffect(() => {
    // This use effect is used to lock the body's scroll
    // when this component is mounted

    const originalOverflow = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";

    // When this component is unmounted
    // the body's scroll is restored to it's former value
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <Stack
      sx={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#000000aa",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
      }}
      justifyContent="center"
      alignItems="center"
      gap={2}
    >
      <ShowWhen when={t("pageStep3.carbonFootprintLoadingText")}>
        <Stack direction="column" alignItems="center" justifyContent="center" gap={2}>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: LoaderData,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
          />

          <Typography variant="h5" color="white">
            {t("pageStep3.carbonFootprintLoadingText")}
          </Typography>
        </Stack>
      </ShowWhen>
    </Stack>
  );
}
